import React from "react";
import { Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import { USABLE_ICONS } from "variables/constants";

const values = [
  {
    icon: "Lightbulb",
    title: "Innovation",
    description: "Challenging the status quo and bringing creative solutions",
    color: "blue",
  },
  {
    icon: "Target",
    title: "Opportunity",
    description: "Seizing moments to grow and help others succeed",
    color: "green",
  },
  {
    icon: "Star",
    title: "Excellence",
    description: "Delivering exceptional quality in everything we do",
    color: "amber",
  },
  {
    icon: "Shield",
    title: "Integrity",
    description: "Doing the right thing, even when no one is watching",
    color: "indigo",
  },
  {
    icon: "Heart",
    title: "Connection",
    description: "Building meaningful relationships and fostering teamwork",
    color: "red",
  },
];

const OurCoreValues = () => {
  return (
    <HeaderComponent
      title="Our Core Values"
      titleClass="text-[16px] font-medium"
      description="The principles that guide everything we do at Hyvid"
      descriptionClass="text-sm muted-text"
    >
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {values.map((item, index) => (
          <Card
            key={index}
            className={`card-theme ${item.color} rounded-xl cursor-pointer hover:shadow-lg transition-all`}
          >
            <div className="space-y-4">
              <div className="flex flex-col items-start gap-3">
                <div className="icon-style p-3 text-white">
                  {item.icon &&
                    USABLE_ICONS[item.icon] &&
                    React.createElement(USABLE_ICONS[item.icon], {
                      className: "h-6 w-6",
                    })}
                </div>

                <h4 className="card-text text-base">{item.title}</h4>

                <p className="text-[13px] muted-text">
                  {item.description}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </HeaderComponent>
  );
};

export default OurCoreValues;